// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3jb-C","footer":"ReportModalFilter_footer__3yNC0"};